// Applies the tenant's brand locale (tenant_brand.locale, delivered by
// GET /api/public/tenant) to the live app. A separate module from
// ./locale on purpose: ./index.ts calls resolveInitialLocale() while
// creating the i18n instance, so ./locale must never import the
// instance back — this module closes that loop at runtime instead.

import i18n from '@/i18n'
import {
  isPublicTenantSurface,
  normalizeBrandLocale,
  rememberTenantLocale,
  savedLocale,
} from '@/i18n/locale'

// Called by useTenant when /api/public/tenant resolves. Remembers the
// brand locale for the next boot's first paint, and — on end-customer
// surfaces only, and never over an explicit saved choice — switches the
// live app to the tenant's language. On the very first visit to a
// tenant this is the moment the browser-language first paint corrects
// itself; every later visit boots straight into the remembered value,
// so there is nothing to flip.
export function applyTenantBrandLocale(brandLocale: unknown, host?: string, path?: string): void {
  const normalized = normalizeBrandLocale(brandLocale)
  if (!normalized) return
  rememberTenantLocale(normalized)
  if (!isPublicTenantSurface(host, path)) return
  if (savedLocale()) return
  if (i18n.global.locale.value === normalized) return
  i18n.global.locale.value = normalized
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized
  }
}
